import { Injectable } from '@angular/core';
import { Platform } from "ionic-angular";
import { Geolocation } from '@ionic-native/geolocation';

@Injectable()

export class GeolocationService {

  constructor(
    public platform: Platform,
    public geolocation: Geolocation
  ) {}

  setup(){
    if (!this.platform.is('cordova')) {
      return;
    }
  }

  public async getCurrentPosition(){
    console.log('GeolocationService.getCurrentPosition');
    const options = {
      enableHighAccuracy: true,
      maximumAge: 60000,
      timeout: 60000
    };
    let data = await this.geolocation.getCurrentPosition(options);
    if (data.coords) {
      console.log('GeolocationService.getCurrentPosition result:');
      console.log(data);
      return data.coords;
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/services/geolocation.service.ts